(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format || undefined);
    }
    return (Number(cents || 0) / 100).toFixed(2);
  }

  function init(root) {
    const media = [...root.querySelectorAll('[data-gallery-media]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    let index = 0;

    function showMedia(nextIndex) {
      if (!media.length) return;
      index = (nextIndex + media.length) % media.length;
      media.forEach((item, position) => {
        item.hidden = position !== index;
        item.classList.toggle('is-active', position === index);
      });
      thumbs.forEach((button, position) => {
        const active = position === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    thumbs.forEach((button, position) => button.addEventListener('click', () => showMedia(position)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showMedia(index - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showMedia(index + 1));

    const form = root.querySelector('[data-product-form]');
    if (form) {
      const variantsNode = form.querySelector('[data-product-variants]');
      const selectedOptionsNode = form.querySelector('[data-selected-options]');
      let variants = [];
      let selected = {};

      try {
        variants = JSON.parse(variantsNode?.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      try {
        const currentOptions = JSON.parse(selectedOptionsNode?.textContent || '[]');
        currentOptions.forEach((value, position) => {
          selected[String(position + 1)] = String(value);
        });
      } catch (error) {
        root.querySelectorAll('[data-option-position].is-selected').forEach((button) => {
          selected[button.dataset.optionPosition] = button.dataset.optionValue;
        });
      }

      const optionButtons = [...root.querySelectorAll('[data-option-position]')];
      const variantInput = form.querySelector('[data-variant-id]');
      const price = root.querySelector('[data-price]');
      const addButton = root.querySelector('[data-add-button]');
      const moneyFormat = root.dataset.moneyFormat || '';

      function findVariant() {
        return variants.find((variant) => variant.options.every((value, position) => selected[String(position + 1)] === String(value)));
      }

      function updateOptions() {
        const activeVariant = findVariant();
        optionButtons.forEach((button) => {
          const position = button.dataset.optionPosition;
          const value = button.dataset.optionValue;
          const isSelected = selected[position] === value;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          button.disabled = false;
        });

        if (!activeVariant) {
          if (variantInput) variantInput.value = '';
          if (addButton) {
            addButton.disabled = true;
            addButton.innerHTML = 'Unavailable <span aria-hidden="true">→</span>';
          }
          return;
        }

        if (variantInput) variantInput.value = activeVariant.id;
        if (price) price.textContent = formatMoney(activeVariant.price, moneyFormat);
        if (addButton) {
          addButton.disabled = !activeVariant.available;
          addButton.innerHTML = (activeVariant.available ? 'Add to cart' : 'Sold out') + ' <span aria-hidden="true">→</span>';
        }
      }

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selected[button.dataset.optionPosition] = button.dataset.optionValue;
          updateOptions();
        });
      });

      updateOptions();
    }

    const wishlistButton = root.querySelector('[data-wishlist-toggle]');
    if (wishlistButton) {
      const storageKey = 'np-vdr-wishlist';
      const productId = String(wishlistButton.dataset.productId || '');
      let saved = [];
      try {
        saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(saved)) saved = [];
      } catch (error) {
        saved = [];
      }

      function syncWishlist() {
        const active = saved.includes(productId);
        wishlistButton.classList.toggle('is-saved', active);
        wishlistButton.setAttribute('aria-pressed', active ? 'true' : 'false');
        wishlistButton.textContent = active ? '♥' : '♡';
      }

      wishlistButton.addEventListener('click', () => {
        saved = saved.includes(productId) ? saved.filter((id) => id !== productId) : saved.concat(productId);
        try {
          localStorage.setItem(storageKey, JSON.stringify(saved));
        } catch (error) {
          // Keep the wishlist usable for the current page even if storage is blocked.
        }
        syncWishlist();
      });
      syncWishlist();
    }
  }

  document.querySelectorAll('[data-product-section]').forEach(init);
})();
